import Role from '../../core/security/role';

const getRoleTranslationKey = (role: Role, author = false) => {
  switch (role) {
    case Role.STUDENT:
      // a user can have multiple roles (teacherAlike)
      // therefore a user could be an author
      return author ? 'ROLES.AUTHOR' : 'ROLES.STUDENT';
    case Role.TEACHER:
      return author ? 'ROLES.AUTHOR' : 'ROLES.TEACHER';
    case Role.EXTERNAL:
      return 'ROLES.EXTERNAL';
    case Role.SALES:
      return 'ROLES.SALES';
    case Role.PUBLISHER:
      return 'ROLES.PUBLISHER';
    case Role.EDITOR:
      return 'ROLES.EDITOR';
    case Role.SUPPORT:
      return 'ROLES.SUPPORT';
    case Role.PRODUCTION:
      return 'ROLES.PRODUCTION';
    case Role.SYSADMIN:
      return 'ROLES.SYSADMIN';
    default:
      return role;
  }
};

export default getRoleTranslationKey;
